export const features = [
  {
    id: "distance",
    icon: "ri-rocket-2-line",
    title: "圧倒的な飛距離",
    subtitle: "OVERWHELMING FLIGHT DISTANCE",
    description:
      "空力最適化された3Dプリント構造により、従来品比+10%の飛距離を実現。狙いのポイントまで一気に届ける。",
    metric: "+10%",
    metricLabel: "vs 従来品",
  },
  {
    id: "stability",
    icon: "ri-compass-3-line",
    title: "飛行の安定性",
    subtitle: "AERODYNAMIC STABILITY",
    description:
      "重力バランスとロケット型構造により、横風下でもブレず、真っ直ぐ突き抜ける投擲軌道。",
    metric: "推進",
    metricLabel: "空力係数",
  },
  {
    id: "release",
    icon: "ri-drop-line",
    title: "撒き餌の放出性",
    subtitle: "PRECISE CHUM RELEASE",
    description:
      "側壁孔により撒き餌が最も効率的に拡散するタイミングを設計。撒き餌の持続時間も長い。",
    metric: "拡散",
    metricLabel: "放出速度",
  },
  {
    id: "sensitivity",
    icon: "ri-pulse-line",
    title: "繊細なアタリ",
    subtitle: "HIGH SENSITIVITY",
    description:
      "軽量ボディと精密構造で、微細なアタリまでダイレクトに伝達。魚のコンタクトを逃さない次世代感度。",
    metric: "沈下",
    metricLabel: "最軽量モデル",
  },
  {
    id: "durability",
    icon: "ri-shield-flash-line",
    title: "壊れにくい強靭さ",
    subtitle: "EXTREME DURABILITY",
    description:
      "高強度樹脂を採用。岩場や高負荷キャストにも耐える、圧倒的な衝撃耐性。",
    metric: "耐久",
    metricLabel: "耐用キャスト",
  },
];